import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  content: {
    display: 'block',
    textAlign: 'center',
    textTransform: 'uppercase',
    backgroundColor: 'transparent',
  },
  success: {
    //backgroundColor: 'rgb(99, 168, 158)',
    backgroundColor: theme.palette.success.dark,
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  NotificationStyling: {
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
  },
}));
